import React from "react"
import { Link } from "react-router-dom"
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap"
import OsImpersonateAction from "../OsImpersonateAction"
import "assets/scss/custom/components/_directoryActions.scss"

export default function OrganizerActions({ account, profilePath, name }) {
  const editId = account.role === "player" ? account.id : account.ownerClubId
  const editLabel = account.role === "player" ? "Edit player account" : "Edit club"
  return <div className="organizer-actions directory-row-actions">
    <Link to={profilePath} className="btn btn-outline-primary btn-sm directory-action-button" aria-label={`Open organizer: ${name}`}>Open</Link>
    <UncontrolledDropdown>
      <DropdownToggle type="button" className="btn btn-light btn-sm directory-action-button" tag="button" aria-label={`Actions for ${name}`}>
        <i className="mdi mdi-dots-horizontal" aria-hidden="true" />
      </DropdownToggle>
      <DropdownMenu right>
        {editId ? <DropdownItem tag={Link} to={`/accounts/${account.role === "player" ? "players" : "clubs"}/${editId}/edit`}>{editLabel}</DropdownItem>
          : <DropdownItem disabled>{editLabel} unavailable</DropdownItem>}
        <OsImpersonateAction account={account} dropdown />
      </DropdownMenu>
    </UncontrolledDropdown>
  </div>
}
